import { com, Nullable } from '@eidu/web'
import FieldId = com.eidu.entity.field.FieldId
import FieldValue = com.eidu.entity.field.FieldValue
import EntityId = com.eidu.entity.EntityId
import LinkKey = com.eidu.entity.link.LinkKey
import ExternalValueKey = com.eidu.entity.user.ExternalValueKey

type Patch = {
  valuesToUpdateByFieldId: Map<FieldId, Nullable<FieldValue>>
  referenceSetItemsToUpdateByFieldId?: Map<FieldId, Map<EntityId, boolean>>
  linksToUpdate: Map<LinkKey, Nullable<string>>
  externalValuesToUpdate: Map<ExternalValueKey, Nullable<string>>
}

export const hasModifications = (patch: Patch) =>
  patch.valuesToUpdateByFieldId.size > 0 ||
  (patch.referenceSetItemsToUpdateByFieldId?.size ?? 0) > 0 ||
  patch.linksToUpdate.size > 0 ||
  patch.externalValuesToUpdate.size > 0

export default Patch
